import { useDataValue } from 'Simple/Data.js'
import useStableValue from 'Logic/useStableValue.js'

export default function useDataConfiguration(props) {
  let parent_company_id = useDataValue({
    context: 'global',
    path: 'current_location.parent_company._id',
    viewPath: props.viewPath,
  })
  let search_term = useStableValue(
    useDataValue({
      context: 'patient_select',
      path: 'search_term',
      viewPath: props.viewPath,
    })
  )
  return {
    variables: {
      search_term,
      parent_company_id,
    },
    pause: !search_term || search_term.length < 3 || !parent_company_id,
  }
}
